// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ForgotPassword_overlay__2RZ3f","content":"ForgotPassword_content__3rxGJ","touched":"ForgotPassword_touched__157-v"};